var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('new-ui-alerts',{ref:"refa",staticClass:"new-ui-notifications",attrs:{"alerts":_vm.alerts,"alerts-key":"id"},on:{"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }